import gql from 'graphql-tag'
import { EntityFields } from '../index'

export const ComponentTypeFragment = gql`
    fragment ComponentType on settings_component_type {
        ${EntityFields}
        name
    }
`
